<template>
  <div class="btn-group" :class="{'is-invalid': layoutData.errorText != null}" data-toggle="buttons">
    <template v-for="option in layoutData.options">
      <label class="btn btn-default input-xsmall" :class="option.value == valueData ? 'active' : ''" style="padding-right: 12px !important;" @click="onChange($event, option.value)">
        <input type="radio" :value="option.value" class="toggle" :checked="option.value == valueData">{{option.label}}</label>
    </template>
  </div>
</template>

<script>
  export default {
    name: "timesheet-field-multistate",
    props: {
      layout: {
        type: Object,
        required: true
      },
      value: {
        default: null
      },
      index: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        layoutData: this.layout,
        valueData: this.value
      }
    },
    watch: {
      value(newval) {
        this.valueData = newval;
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.options
      }
    },
    methods: {
      onChange(e, v) {
        this.valueData = v;
        this.$emit("change", e, this.layoutData, v, this.index);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>